import CardSelectable from './CardSelectable';

export default CardSelectable;
